// extracted by mini-css-extract-plugin
export default {"section":"b3y7Mt","option":"c3y7Mt","selected":"d3y7Mt","checkBox":"e3y7Mt","iconWrapper":"f3y7Mt","icon":"g3y7Mt"};